import * as t from 'io-ts'

// These types are specifically for managing third party stores blacklist,
// so we don't need or want to unify with the Store type that already
// exists and has business meaning.
export const BLThirdPartyStoreC = t.strict({
  storeKey: t.string,
  storeName: t.string,
  storeDescription: t.string,
  thirdParty: t.union([t.literal('Access'), t.literal('Entertainment'), t.undefined, t.null]),
}, 'BlacklistAccessStores')

export type BLThirdPartyStore = t.TypeOf<typeof BLThirdPartyStoreC>
export type BLThirdPartyStoreCT = t.Type<BLThirdPartyStore>
